import React from 'react'
import './Label.css'

const Label = ({ 
  children, 
  htmlFor = '', 
  required = false, 
  disabled = false, 
  className = '',
  ...props 
}) => {
  const classes = [
    'label',
    required && 'label-required',
    disabled && 'label-disabled',
    className
  ].filter(Boolean).join(' ')

  return (
    <label htmlFor={htmlFor} className={classes} {...props}>
      {children}
      {required && <span className="label-asterisk">*</span>}
    </label>
  )
}

export default Label
